import { render, staticRenderFns } from "./DeclaracaoSubstituicao.vue?vue&type=template&id=6627a259&scoped=true&"
import script from "./DeclaracaoSubstituicao.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoSubstituicao.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoSubstituicao.vue?vue&type=style&index=0&id=6627a259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6627a259",
  null
  
)

export default component.exports